import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens ({ commit, dispatch }, params) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("evento", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        dispatch("loadingAux/habilitarLoading", false, { root: true });
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async ItemProduto ({ commit, dispatch }, params) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("evento", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItensProdutos", resp.data.itens);
        dispatch("loadingAux/habilitarLoading", false, { root: true });
      })
      .catch(() => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        Helpers.logout();
      });
  },
  async Store ({ state, commit, dispatch }) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "evento",
      headers,
      data: state.item
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        return "ok";
      })
      .catch(() => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        Helpers.logout();
      });
  },
  async Delete ({ commit, dispatch }, params) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("evento/" + params.id, {
        headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        dispatch("loadingAux/habilitarLoading", false, { root: true });
      })
      .catch(() => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        Helpers.logout();
      });
  },
  async Produtos ({ commit, dispatch }, params) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("evento", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        let produtos = [];
        resp.data.itens.forEach(element => {
          produtos.push(element);
        });
        commit("setProdutos", produtos);
        dispatch("loadingAux/habilitarLoading", false, { root: true });
      })
      .catch(() => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        Helpers.logout();
      });
  },
  async Filtro ({ dispatch }, params) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("evento", {
        headers,
        params
      })
      .then(resp => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        localStorage.setItem("token", resp.data.token);
        return resp.data.itens;
      })
      .catch(() => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        Helpers.logout();
      });
  },
  async ItemProdutoDesconto ({ commit }, params) {
    return commit("setItemProdutoDesconto", params);
  },
  async ItemProdutoPreco ({ commit }, params) {
    return commit("setItemProdutoPreco", params);
  },
  async ItemProdutoMarkup ({ commit }, params) {
    return commit("setItemProdutoMarkup", params);
  },
  async Simular ({ dispatch }, params) {
    dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("evento", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        return resp.data.itens;
      })
      .catch(() => {
        dispatch("loadingAux/habilitarLoading", false, { root: true });
        Helpers.logout();
      });
  }
};
